export default {"src":"/_next/static/media/icon_color_pedometer_light.324ee1c3.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};